import axios from "axios";

const aliados = {
  state: () => ({
    aliados: [],
    aliado: {},
    aliadosCampesena: [],
    aliadoCampesena: {},
  }),

  getters: {
    obtenerAliados(state) {
      return state.aliados;
    },

    obtenerAliado(state) {
      return state.aliado;
    },

    obtenerAliadosCampesena(state) {
      return state.aliadosCampesena;
    },

    obtenerAliadoCampesena(state) {
      return state.aliadoCampesena;
    },
  },

  mutations: {
    enviarAliados(state, aliados) {
      state.aliados = aliados;
    },

    enviarAliado(state, aliado) {
      state.aliado = aliado;
    },

    enviarAliadosCampesena(state, aliados) {
      state.aliadosCampesena = aliados;
    },

    enviarAliadoCampesena(state, aliado) {
      state.aliadoCampesena = aliado;
    },
  },

  actions: {
    // Senasoft
    registrarAliado(context, aliado) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/aliados", aliado, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },

    gestionarAliados(context) {
      axios
        .get("api/aliados")
        .then((response) => {
          const aliados = [];

          response.data.results.forEach((aliado) => {
            aliados.push({
              id: aliado.id_aliado,
              aliado: aliado.aliado,
              logotipo: aliado.logotipo,
              descripcion: aliado.descripcion,
              direccion: aliado.direccion,
              telefono: aliado.telefono,
              correo: aliado.correo,
              contacto_aliado: aliado.contacto_aliado,
              telefono_contacto_aliado: aliado.telefono_contacto_aliado,
              correo_contacto_aliado: aliado.correo_contacto_aliado,
            });
          });

          context.commit("enviarAliados", aliados);
        })
        .catch(() => {});
    },

    detallesAliado(context, aliado) {
      axios
        .get("api/aliados/" + aliado)
        .then((response) => {
          const results = response.data.results;

          const aliado = {
            aliado: results.aliado,
            logotipo: results.logotipo,
            descripcion: results.descripcion,
            direccion: results.direccion,
            telefono: results.telefono,
            correo: results.correo,
            contacto_aliado: results.contacto_aliado,
            telefono_contacto_aliado: results.telefono_contacto_aliado,
            correo_contacto_aliado: results.correo_contacto_aliado,
          };

          context.commit("enviarAliado", aliado);
        })
        .catch(() => {});
    },

    actualizarAliado(context, aliado) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/aliados/" + aliado.get("id"), aliado, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },

    
    // Campesena

    registrarAliadoCampesena(context, aliado) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/campesena/aliados", aliado, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    gestionarAliadosCampesena(context) {
      axios
        .get("api/campesena/aliados")
        .then((response) => {
          const aliados = [];
          response.data.results.forEach((aliado) => {
            aliados.push({
              id: aliado.id_aliado,
              aliado:
                aliado.aliado.charAt(0).toUpperCase() + aliado.aliado.slice(1),
              logotipo: aliado.logotipo,
              descripcion: aliado.descripcion,
              direccion: aliado.direccion,
              telefono: aliado.telefono,
              correo: aliado.correo,
              contacto_aliado: aliado.contacto_aliado.replace(/\b\w/g, (char) =>
                char.toUpperCase()
              ),
              telefono_contacto_aliado: aliado.telefono_contacto_aliado,
              correo_contacto_aliado: aliado.correo_contacto_aliado,
            });
          });

          context.commit("enviarAliadosCampesena", aliados);
        })
        .catch(() => {});
    },

    actualizarAliadoCampesena(context, aliado) {
      return new Promise((resolve, reject) => {
        axios
          .post(`api/campesena/aliados/${aliado.get("id_aliado")}`, aliado, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },

    obtenerAliadoCampesenaId(context, idAliado) {
      axios
        .get(`api/campesena/aliados/${idAliado}`)
        .then((response) => {
          const results = response.data.results;

          const aliado = {
            aliado:
              results.aliado.charAt(0).toUpperCase() + results.aliado.slice(1),
            logotipo: results.logotipo,
            descripcion: results.descripcion,
            direccion: results.direccion,
            telefono: results.telefono,
            correo: results.correo,
            contacto_aliado: results.contacto_aliado.replace(/\b\w/g, (char) =>
              char.toUpperCase()
            ),
            telefono_contacto_aliado: results.telefono_contacto_aliado,
            correo_contacto_aliado: results.correo_contacto_aliado,
          };

          context.commit("enviarAliadoCampesena", aliado);
        })
        .catch(() => {});
    },
  },
};

export default aliados;
